
<div *ngIf="card" class="btn-track chip d-inline-block px-2 py-1" (click)="onLikeClick()">
    <div class="d-flex flex-row align-items-center">
        <img class="picto-medium" [src]="isLiked ? '../../../assets/images/231116/pictos/Hand-thumbs-up-fill.svg' : '../../../assets/images/231116/pictos/Hand-thumbs-up.svg'" />
        <div *ngIf="cardService.getNumberOfLike(card) == undefined" class="typo-chip ms-1">{{ 'wap1_c_like_like' | translate }}</div>
        <div *ngIf="cardService.getNumberOfLike(card) as nbLike" class="typo-chip ms-1">{{ nbLike }}</div>
    </div>
</div>
